import React, { useState } from 'react'

import CrosswordModal from '../components/Modals/CrosswordModal/CrosswordModal'

import ModalEditedBlock from '../components/ModalEditedBlock/ModalEditedBlock'
import StatisticPreview from '../components/StatisticPreview/StatisticPreview'

import Preview from './components/Preview/Preview'

const Crossword = ({
    struct,
    enableTimer,
    colorTheme,
    letterColor,
    fontFamily,
    onUpdate,
    id,
    isTransparentBackground,
    backgroundColor,
    backgroundImage,
}) => {
    const [isShowModal, setIsShowModal] = useState(false)

    return (
        <ModalEditedBlock onEdit={() => setIsShowModal(true)}>
            {enableTimer && <StatisticPreview />}
            <Preview
                struct={struct}
                colorTheme={colorTheme}
                letterColor={letterColor}
                fontFamily={fontFamily}
                isTransparentBackground={isTransparentBackground}
                backgroundColor={backgroundColor}
                backgroundImage={backgroundImage}
            />

            {isShowModal && (
                <CrosswordModal
                    data={{
                        structure: struct,
                        colorTheme,
                        id,
                    }}
                    methods={{
                        closeModal: () => setIsShowModal(false),
                        save: onUpdate,
                    }}
                />
            )}
        </ModalEditedBlock>
    )
}

export default Crossword
